import { render, staticRenderFns } from "./ManageFonts.vue?vue&type=template&id=b0a32430&scoped=true&"
import script from "./ManageFonts.vue?vue&type=script&lang=js&"
export * from "./ManageFonts.vue?vue&type=script&lang=js&"
import style0 from "./ManageFonts.vue?vue&type=style&index=0&id=b0a32430&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a32430",
  null
  
)

export default component.exports